import { render, staticRenderFns } from "./question-integer.vue?vue&type=template&id=deca85c0&scoped=true"
import script from "./question-integer.vue?vue&type=script&lang=js"
export * from "./question-integer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca85c0",
  null
  
)

export default component.exports